import React from 'react';

const Footer = () => {
    return ( 
        <footer>
            <div>
                Server is listening on Heroku.com </div> <div> ❂ </div> <div> Domain on netlify.com
                </div>
        </footer>
     );
}
 
export default Footer;